import { emptyValidator, formValidator } from "../../validators";

const trailersMasterValidationStatus = {
  trlTrailerNo: {
    validators: [emptyValidator()],
    name: "Trailer Number",
  },
  trlTrailerType:{
    validators: [emptyValidator()],
    name: "Trailer Type",
  },
};

export const trailersMasterValidation = (trailers) => {
  return formValidator(trailers, trailersMasterValidationStatus);
};
